// Compute score for an assessment form based on field-level `marks`.
// Scoring rules per field type:
//  - radio:    value === (field.correct || "Yes")  -> full marks
//  - image:    a file uploaded (non-empty)          -> full marks
//  - checkbox: at least one option selected          -> full marks
//  - select:   field.optionMarks[value] if provided, else any value -> full marks
//  - other:    any non-empty value                   -> full marks
export function computeScore(form, values) {
  let score = 0;
  let max = 0;
  (form.fields || []).forEach((f) => {
    if (f.marks == null) return;
    max += f.marks;
    const v = values[f.name];
    let awarded = 0;
    if (f.type === "radio") {
      awarded = v === (f.correct || "Yes") ? f.marks : 0;
    } else if (f.type === "image") {
      awarded = v ? f.marks : 0;
    } else if (f.type === "checkbox") {
      awarded = Array.isArray(v) && v.length > 0 ? f.marks : 0;
    } else if (f.type === "select") {
      awarded = f.optionMarks ? (f.optionMarks[v] || 0) : (v ? f.marks : 0);
    } else {
      awarded = v ? f.marks : 0;
    }
    score += awarded;
  });
  return { score, max };
}

// Trim trailing .0 / .00 for clean display (e.g. 93.75, 750, 656.25)
export function fmtMarks(n) {
  if (n == null) return "—";
  return Number(n).toFixed(2).replace(/\.?0+$/, "");
}
